<template>

  <!-- Meeting add validation -->
  <validator name="validator">

    <form novalidate>
      <fieldset>

        <legend>Contact</legend>

        <!-- Contact -->
        <div v-if="this.$route.params.contactId > 0">
          Participant : {{ contact.leader_lastname }} {{ contact.leader_firstname }}
          <input type="hidden" id="contact" class="form-control" value="{{ contact.id }}" v-model ="data.contactId" />
        </div>
        <div class="form-group" v-else>
          <label for="contact">Participant *</label>
          <select
            id      = "contact"
            v-model = "data.contactId"
            class   = "form-control"
            @change = "showParcours()"
            v-validate:contact = "validationRules.contact"
          >
          <option v-for="contacttmp of contacts" :value="contacttmp.id" >
            <!-- :class="{ 'me': contacttmp.id == contact.id}" :selected="contacttmp.id == contact.id"> -->
            {{ contacttmp.leader_lastname }} {{ contacttmp.leader_firstname }}
          </option>
          </select>
          <small class="form-text text-danger" v-if="$validator.contact.required">Vous devez choisir un participant</small>
        </div>

        <!-- Project -->
        <div class="form-group">
          <label for="project">Parcours</label>
          <select
            id      = "project"
            v-model = "data.projectId"
            class   = "form-control"
          >
          <option value=""></option>
          <option v-for="projecttmp of projects" :value="projecttmp.id" :class="{ 'me': projecttmp.id == project.id}" :selected="projecttmp.id == project.id" >
            {{ projecttmp.name }} - {{ projecttmp.first_meeting_date }} | {{ projecttmp.exit_date }}
          </option>
          </select>
        </div>
      
        <!-- Phase -->
        <div class="form-group">
          <label for="phase">Phase</label>
              <select id="phase_id" name="phase_id" v-model="data.phaseId" class="form-control">
                <option value=""></option>
                  <option v-for="phase in phases" :key="phase.id" v-bind:value="phase.id">{{ phase.name }}</option>
              </select>
        </div>

      </fieldset>

      <fieldset>

        <legend>Informations générales</legend>

        <!-- Title -->
        <div class="form-group">
          <label for="title">Nom de l'événement</label>
          <input
            id               = "title"
            class            = "form-control"
            type             = "text"
            v-model          = "data.title"
          >
          <!-- <small class="form-text text-danger" v-if="$validator.title.required">Vous devez saisir un titre</small> -->
        </div>
        <div class="row form-group">
          <div class="col-sm-6">
            <div class="">
              <switch :value.sync = "data.rdvindividuel" >Rendez-vous individuel</switch>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="">
              <switch :value.sync = "data.rdvcollectif" >Rendez-vous collectif</switch>
            </div>
          </div>
        </div>
        <!-- User -->
        <!--
        <div class="form-group" >
          <label for="">Agenda de</label>
          <select
            id      = "user"
            class   = "form-control"
            v-model = "data.userId"
          >
          <option value=""></option>
          <option v-for="user of users" :value="user.id" :class="{ 'me': user.id == authenticatedUser.id }" >
            {{ user.firstname }} {{ user.lastname }}
          </option>
          </select>
        </div>
        -->

        <div class="form-inline">

          <!-- Day -->
          <label for="data_day">Le</label>
          <!--
          <date-picker :time.sync="data.day" :option="datepickerOptions" ></date-picker>
          -->
          <input
            id               = "data_day"
            class            = "form-control"
            type             = "text"
            v-model          = "data.day"
          >

          <!-- Start hour -->
          <label for="hour">de</label>
          <select
            id              = "startHour"
            class           = "form-control"
            v-model         = "data.startHour"
            v-validate:hour = "validationRules.hour"
          >
            <option v-for="hour in businessHours" :value="hour" >{{ hour }}</option>
          </select>

          <!-- Start minutes -->
          <select
            id              = "startMinutes"
            class           = "form-control"
            v-model         = "data.startMinutes"
            v-validate:hour = "validationRules.hour"
          >
            <option v-for="minutes in ['00', '15', '30', '45']" >{{ minutes }}</option>
          </select>
          <label for="">à</label>

          <!-- End hour -->
          <select
            id              = "endHour"
            class           = "form-control"
            v-model         = "data.endHour"
            v-validate:hour = "validationRules.hour"
          >
            <option v-for="hour in businessHours" :value="hour" >{{ hour }}</option>
          </select>

          <!-- End minutes -->
          <select
            id              = "endMinutes"
            class           = "form-control"
            v-model         = "data.endMinutes"
            v-validate:hour = "validationRules.hour"
          >
            <option v-for="minutes in ['00', '15', '30', '45']" >{{ minutes }}</option>
          </select>

          <label for="duration">Durée de l'événement</label>
          <input
            id               = "duration"
            class            = "form-control"
            type             = "text"
            v-model          = "data.duration"
            v-validate:duration = "validationRules.duration"
          >

        </div>

        <div class="row form-group">
          <div class="col-sm-6">
            <div class="">
              <switch :value.sync = "data.all_day" >Toute la journée</switch>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="">
              <switch :value.sync = "data.recurring" >Rendez-vous récurrent</switch>
            </div>
          </div>
        </div>
      </fieldset>

        <!-- Lieu du rdv -->
        <div class="form-group">
          <label for="place">Lieu du rendez-vous</label>
              <select id="place_id" name="place_id" v-model="data.placeId" class="form-control">
                <option value=""></option>
                  <option v-for="place in places" :key="place.id" v-bind:value="place.id">{{ place.name }}</option>
              </select>
        </div>

      <fieldset>

        <legend>Intervenants</legend>

        <!-- Intervenant1 -->
        <div class="form-group">
          <label for="firstintervenant">Agenda de / Intervenant 1 *</label>
              <select id="firstintervenant_id" name="firstintervenant_id" v-model="data.firstintervenantId" class="form-control" v-validate:firstintervenant_id = "validationRules.firstintervenant_id">
                  <!-- v-for="firstintervenant in firstintervenants" -->
                  <option v-for="user in users" :key="user.id" v-bind:value="user.id" :class="{ 'me': user.id == authenticatedUser.id}" :selected="user.id == authenticatedUser.id">{{ user.firstname }} {{ user.lastname }}</option>
              </select>
              <small class="form-text text-danger" v-if="$validator.firstintervenant_id.required">Vous devez choisir un intervenant</small>
        </div>

        <!-- Intervenant2 -->
        <div class="form-group">
          <label for="secondintervenant">Intervenant 2</label>
              <select id="secondintervenant_id" name="secondintervenant_id" v-model="data.secondintervenantId" class="form-control">
                  <option value=""></option>
                  <option v-for="firstintervenant in firstintervenants" :key="secondintervenant.id" v-bind:value="firstintervenant.id">{{ firstintervenant.firstname }} {{ firstintervenant.lastname }}</option>
              </select>
        </div>

        <!-- Intervenant3 -->
        <div class="form-group">
          <label for="thirdintervenant">Intervenant 3</label>
              <select id="thirdintervenant_id" name="thirdintervenant_id" v-model="data.thirdintervenantId" class="form-control">
                  <option value=""></option>
                  <option v-for="firstintervenant in firstintervenants" :key="thirdintervenant.id" v-bind:value="firstintervenant.id">{{ firstintervenant.firstname }} {{ firstintervenant.lastname }}</option>
              </select>
        </div>

        <!-- Intervenant extérieur -->
        <div class="form-group">
          <label for="">Intervenant extérieur</label>
          <input
            id               = "intervenantexterieur"
            class            = "form-control"
            type             = "text"
            v-model          = "data.intervenantexterieur"
          >
        </div>
      </fieldset>

      <fieldset>

        <legend>Description</legend>

        <!-- Description 
        <label for="">Description</label>
        <textarea
          id                     = "description"
          class                  = "form-control"
          rows                   = "8"
          v-model                = "data.description"
          v-validate:description = "validationRules.description"
        >
        </textarea>-->

        <!-- Présence -->
        <div class="form-group">
          <label for="presence">Présence</label>
              <select id="presence_id" name="presence_id" v-model="data.presenceId" class="form-control">
                  <option value=""></option>
                  <option v-for="presence in presences" :key="presence.id" v-bind:value="presence.id">{{ presence.name }}</option>
              </select>
        </div>

        <!-- Contenu -->
        <div class="form-group">
          <label for="content">Contenu</label>
              <select id="content_id" name="content_id" v-model="data.contentId" class="form-control">
                  <option value=""></option>
                  <option v-for="content in contents" :key="content.id" v-bind:value="content.id">{{ content.name }}</option>
              </select>
        </div>

        <!-- Formation -->
        <div class="form-group">
          <label for="training">Formation pratique</label>
              <select id="training_id" name="training_id" v-model="data.trainingId" class="form-control">
                  <option value=""></option>
                  <option v-for="training in trainings" :key="training.id" v-bind:value="training.id">{{ training.name }}</option>
              </select>
        </div>

        <!-- Synthèse -->
        <label for="">Synthèse</label>
        <textarea
          id                     = "synthese"
          class                  = "form-control"
          rows                   = "8"
          v-model                = "data.synthese"
        >
        </textarea>

        <!-- Observations 
        <label for="">Observations</label>
        <textarea
          id                     = "observations"
          class                  = "form-control"
          rows                   = "8"
          v-model                = "data.observations"
        >
        </textarea>-->

        <!-- Convention -->
        <div class="form-group">
          <label for="">Convention</label>
          <input
            id               = "convention"
            class            = "form-control"
            type             = "text"
            v-model          = "data.convention"
          >
        </div>

      </fieldset>

      <!-- Errors -->
      <div v-if="$validator.errors" >
        <hr>
        <ul>
          <li class="errors" v-for="error in $validator.errors" >{{ error.message }}</li>
        </ul>
      </div>

    </form>

  </validator>

</template>

<script>
  // Npm packages
  import DatePicker from 'vue-datepicker/vue-datepicker-1.vue'
  import { Switch } from 'mint-ui'

  // Options
  import { businessHours, datepickerOptions } from 'src/options/date'

  // jQuery
  // import $ from 'jquery'

  // getProjectsOfContact
  import store from 'src/vuex/store'
  import { getProjectsOfContact } from 'src/vuex/actions/contactActions'

  export default {
    props: [ 'data', 'validationRules', 'validation', 'phases', 'contents', 'trainings', 'presences', 'places', 'firstintervenants', 'users', 'contacts', 'projects', 'authenticated-user', 'contactId', 'projectId', 'contact', 'project' ],
    validators: {
      hourAfter (val) {
        // TODO move this out of component (validator)
        return Number(this.vm.data.startHour + this.vm.data.startMinutes) < Number(this.vm.data.endHour + this.vm.data.endMinutes)
      }
    },
    data () {
      return {
        businessHours,
        datepickerOptions
      }
    },
    methods: {
      projectName: function (project) {
        let nameReturned
        // console.log('createName ' + project.name + ' ' + project.project_type_id)
        if (project.project_type_id === '1') {
          nameReturned = 'ACA ' + project.name
        } else if (project.project_type_id === '2') {
          nameReturned = 'REGION ' + project.name
        } else if (project.project_type_id === '3') {
          nameReturned = 'COUVEUSE ' + project.name
        } else if (project.project_type_id === '4') {
          nameReturned = 'COUVEUSE MOSSON ' + project.name
        } else if (project.project_type_id === '5') {
          nameReturned = 'FORMATION CERTIFIANTE ' + project.name
        } else if (project.project_type_id === '6') {
          nameReturned = 'FORMATION AUTRES ' + project.name
        } else if (project.project_type_id === '7') {
          nameReturned = 'CLUB ' + project.name
        } else if (project.project_type_id === '8') {
          nameReturned = 'CAE ' + project.name
        } else if (project.project_type_id === '9') {
          nameReturned = 'PEPITE ' + project.name
        } else if (project.project_type_id === '1000') {
          nameReturned = 'AUTRE ' + project.name
        }
        return nameReturned
      },
      showParcours: function () {
        // console.log('changeParcours' + JSON.stringify(contacts.projectsOfcontact))
        // let projectSelect = $('#project' + this.data.contactId)
        // console.log('show project of ' + JSON.stringify(this.data.contactId))
        getProjectsOfContact(store, JSON.stringify(this.data.contactId))
      },
      showParcoursInit: function () {
        getProjectsOfContact(store, this.$route.params.contactId)
      }
    },
    components: {
      DatePicker,
      Switch
    },
    ready () {
      if (this.$route.params.contactId > 0) {
        this.showParcoursInit(this.$route.params.contactId)
      }
    }
  }
</script>

<style lang="scss" >
  .show { display : block }
  .hide { display : none !important }
</style>



// WEBPACK FOOTER //
// MeetingForm.vue?60b8312c